import { render, staticRenderFns } from "./ShortCut.vue?vue&type=template&id=39817ff2&scoped=true&"
import script from "./ShortCut.vue?vue&type=script&lang=js&"
export * from "./ShortCut.vue?vue&type=script&lang=js&"
import style0 from "./ShortCut.vue?vue&type=style&index=0&id=39817ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39817ff2",
  null
  
)

export default component.exports